unit Essentials.Web.CustomNames.EditValueForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Essentials.Web.BaseEditForm, Data.DB, WEBLib.DB,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.DBCtrls,
  Essentials.Web.Shared;

type
  TCustomNamesEditValue = class(TEssentialsBaseEditForm)
    CustomNamesEdit: TDBEdit;
    EntitySelector: TDBLookupComboBox;
    FieldSelector: TDBLookupComboBox;
    procedure WebFormCreate(Sender: TObject);
    procedure EntitySelectorChange(Sender: TObject);
    procedure FieldSelectorChange(Sender: TObject);
  private
    { Private declarations }
    function AllRequiredFieldsAreSet: Boolean; override;
    procedure SetEditMode(const Value: TEditMode); override;
  public
    procedure LoadEntityList;
  protected procedure LoadDFMValues; override; end;

var
  CustomNamesEditValue: TCustomNamesEditValue;

implementation

uses Essentials.Web.Manager, Essentials.Shared,
Generics.Collections, SMX.Web.Utils;

{$R *.dfm}

function TCustomNamesEditValue.AllRequiredFieldsAreSet: Boolean;
begin
  Result := (EntitySelector.ItemIndex > -1) and (FieldSelector.ItemIndex > -1);
end;

procedure TCustomNamesEditValue.EntitySelectorChange(Sender: TObject);
var
  selectedValue: string;
  lFields: TList<string>;
  fld: string;
begin
  selectedValue := EntitySelector.Value;
  FieldSelector.LookupValues.Clear;

//  lFields := EssentialsManager.LookUpManager.RegisteredFields[selectedValue];
  lFields := EssentialsManager.CustomNamesManager.RegisteredFields[selectedValue];

  if Assigned(lFields) then
  begin
    for fld in lFields do
    begin
      FieldSelector.LookupValues.AddPair(fld, TUtils.SplitOnCaps(fld));
    end;
  end;

  if FieldSelector.LookupValues.Count > 0 then
    FieldSelector.ItemIndex := 0;

  UpdateState;
end;

procedure TCustomNamesEditValue.FieldSelectorChange(Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TCustomNamesEditValue.LoadEntityList;
var
  lDef: TdtoLookupDef;
  lName, lCustom: string;
  lAssigned: Boolean;
begin
  for lDef in EssentialsManager.CustomNamesManager.RegisteredEntities do
  begin
    lName := lDef.EntityClassName;
    lAssigned := Assigned(EssentialsManager.CustomNamesManager);
    if lAssigned then
    begin
      lCustom := EssentialsManager.CustomNamesManager.EntityCustomName(lName);
      EntitySelector.LookupValues.AddPair(lName, lCustom);
    end;
  end;

  if EntitySelector.LookupValues.Count > 0 then
  begin
    EntitySelector.ItemIndex := 0;
    EntitySelectorChange(EntitySelector);
  end;

end;

procedure TCustomNamesEditValue.SetEditMode(const Value: TEditMode);
begin
  inherited;
  if FEditMode <> None then
  begin
    EntitySelector.Enabled := FEditMode = Add;
    FieldSelector.Enabled := FEditMode = Add;
    CustomNamesEdit.Enabled := True;
    CustomNamesEdit.SetFocus;
  end;
end;

procedure TCustomNamesEditValue.WebFormCreate(Sender: TObject);
begin
  inherited;
  EntitySelector.Enabled := False;
  FieldSelector.Enabled := False;
  CustomNamesEdit.Enabled := False;
end;


procedure TCustomNamesEditValue.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CustomNamesEdit := TDBEdit.Create('essentials.customnames.customname.edit');
  EntitySelector := TDBLookupComboBox.Create('essentials.customnames.entity.selector');
  FieldSelector := TDBLookupComboBox.Create('essentials.customnames.field.selector');

  TitleBarLabel.BeforeLoadDFMValues;
  CustomNamesEdit.BeforeLoadDFMValues;
  EntitySelector.BeforeLoadDFMValues;
  FieldSelector.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    TitleBarLabel.Width := 100;
    TitleBarLabel.Caption := 'Edit Custom Name';
    CustomNamesEdit.SetParentComponent(Self);
    CustomNamesEdit.Name := 'CustomNamesEdit';
    CustomNamesEdit.Left := 375;
    CustomNamesEdit.Top := 113;
    CustomNamesEdit.Width := 242;
    CustomNamesEdit.Height := 22;
    CustomNamesEdit.ChildOrder := 4;
    CustomNamesEdit.ElementClassName := 'form-control';
    CustomNamesEdit.ElementFont := efCSS;
    CustomNamesEdit.ElementPosition := epIgnore;
    CustomNamesEdit.HeightStyle := ssAuto;
    CustomNamesEdit.HeightPercent := 100.000000000000000000;
    CustomNamesEdit.Text := 'CustomNamesEdit';
    CustomNamesEdit.WidthStyle := ssAuto;
    CustomNamesEdit.WidthPercent := 100.000000000000000000;
    CustomNamesEdit.DataField := 'CustomName';
    CustomNamesEdit.DataSource := DataSource;
    EntitySelector.SetParentComponent(Self);
    EntitySelector.Name := 'EntitySelector';
    EntitySelector.Left := 62;
    EntitySelector.Top := 113;
    EntitySelector.Width := 145;
    EntitySelector.Height := 22;
    EntitySelector.ElementClassName := 'custom-select';
    EntitySelector.ElementFont := efCSS;
    EntitySelector.HeightPercent := 100.000000000000000000;
    EntitySelector.WidthPercent := 100.000000000000000000;
    SetEvent(EntitySelector, Self, 'OnChange', 'EntitySelectorChange');
    EntitySelector.DataField := 'EntityClassName';
    EntitySelector.DataSource := DataSource;
    FieldSelector.SetParentComponent(Self);
    FieldSelector.Name := 'FieldSelector';
    FieldSelector.Left := 216;
    FieldSelector.Top := 113;
    FieldSelector.Width := 145;
    FieldSelector.Height := 22;
    FieldSelector.ElementClassName := 'custom-select';
    FieldSelector.ElementFont := efCSS;
    FieldSelector.HeightPercent := 100.000000000000000000;
    FieldSelector.WidthPercent := 100.000000000000000000;
    SetEvent(FieldSelector, Self, 'OnChange', 'FieldSelectorChange');
    FieldSelector.DataField := 'FieldName';
    FieldSelector.DataSource := DataSource;
  finally
    TitleBarLabel.AfterLoadDFMValues;
    CustomNamesEdit.AfterLoadDFMValues;
    EntitySelector.AfterLoadDFMValues;
    FieldSelector.AfterLoadDFMValues;
  end;
end;

end.